import { Link, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { useSidebarStore } from "@/stores/sidebarStore";
import {
  LayoutDashboard,
  Radio,
  Map,
  Settings,
} from "lucide-react";

const menuItems = [
  { icon: LayoutDashboard, label: "Dashboard", href: "/dashboard" },
  { icon: Radio, label: "Providers", href: "/providers" },
  { icon: Map, label: "Regions", href: "/regions" },
  { icon: Settings, label: "Settings", href: "/account" },
] as const;

export function SidebarNavigation() {
  const { isOpen } = useSidebarStore();
  const location = useLocation();

  return (
    <div className="flex flex-col gap-2 p-4">
      {menuItems.map((item) => {
        const Icon = item.icon;
        const isActive = location.pathname === item.href;

        return (
          <Button
            key={item.href}
            variant={isActive ? "secondary" : "ghost"}
            className={cn(
              "justify-start gap-2",
              !isOpen && "justify-center p-2"
            )}
            asChild
          >
            <Link to={item.href}>
              <Icon className="h-4 w-4" />
              {isOpen && <span>{item.label}</span>}
            </Link>
          </Button>
        );
      })}
    </div>
  );
} 
